import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService, Language } from '../../../services/language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mobile-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-language-selector.html',
  styleUrl: './mobile-language-selector.scss'
})
export class MobileLanguageSelectorComponent implements OnInit, OnDestroy {
  currentLanguage = 'en';
  languages: Language[] = [];
  showDropdown = false;
  private subscriptions: Subscription[] = [];

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.languageService.languages$.subscribe(languages => {
        this.languages = languages;
      }),
      this.languageService.currentLanguage$.subscribe(language => {
        this.currentLanguage = language;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  selectLanguage(languageCode: string): void {
    this.languageService.setLanguage(languageCode);
    this.showDropdown = false;
  }

  getCurrentLanguage(): Language | undefined {
    return this.languages.find(lang => lang.code === this.currentLanguage);
  }
}

